import React, { useEffect, useState } from 'react';
import { Row, Button, Alert, Box, Input, Col } from '@intech/web-ui';
import { useHistory } from 'react-router-dom';
import { FuncionarioDados, PlanoVinculadoEntidade, SaldoContribuicoesFaelceEntidade } from '@entidades';
import { FuncionarioService, PlanoService, FichaFinanceiraService } from '@services';
import { Header } from './Header';
import { BoxInfoSimulador } from './BoxInfoSimulador';
import { ComboData } from "./ComboSimulador";
import { Checkbox, ToggleBox, WrapRow, AutoColumn, Label, UnderlineBoldText } from './styles';
import { ComboPercentual } from './ComboPercentual';
import { ComboPrazo } from './ComboPrazo';
import { ComboRentabilidade } from './ComboRentabilidade';
import { LoadingComponent, MasterPage } from '@components';
import { NumFuncionalidade } from '../../helpers/BloqueioFuncionalidade';

export const SimuladorAposentadoria: React.FC = (props) => {
  const history = useHistory();

  const IDADE_MINIMA_F = 48;
  const IDADE_MINIMA_M = 50;

  const [AlertText, setAlertText] = useState<string>("");

  const [Dados, setDados] = useState<FuncionarioDados>();
  const [NomeUsuario, setNomeUsuario] = useState<string>("");
  const [IdadeCompleta, setIdadeCompleta] = useState<string>("");
  const [TempoPatrocinadora, setTempoPatrocinadora] = useState<string>("");

  const [IdadeAposentadoria, setIdadeAposentadoria] = useState<string>("");
  const [Percentual, setPercentual] = useState<string>("0");
  const [Prazo, setPrazo] = useState<string>("240");
  const [Rentabilidade, setRentabilidade] = useState<string>("3.5");

  const [ComboIdade, setComboIdade] = useState<Array<ComboData>>(new Array<ComboData>());

  const [AtivoCD, setAtivoCD] = useState<boolean>(false);
  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>();
  const [TempoPlano, setTempoPlano] = useState<string>("");

  const [Referencia, setReferencia] = useState<string>("");
  const [SRC, setSRC] = useState<number>(0);

  const [Saldo, setSaldo] = useState<SaldoContribuicoesFaelceEntidade>();

  const [Contribuicao, setContribuicao] = useState<number>(0);

  const [Manifesto, setManifesto] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        const Planos = await PlanoService.Buscar();

        const PlanoCD = Planos.find((x => (
          x.CD_PLANO === "0002" && (
            x.CD_CATEGORIA === "1" ||
            x.CD_CATEGORIA === "3" ||
            x.CD_CATEGORIA === "5" ||
            (x.CD_CATEGORIA === "6" && (
              x.CD_SIT_PLANO === "28" ||
              x.CD_SIT_PLANO === "29" ||
              x.CD_SIT_PLANO === "30"
            ))
          )
        )));

        if (PlanoCD !== undefined) {
          const dados = await FuncionarioService.Buscar();

          const Idade = parseInt(dados.IDADE, 10);
          const IdadeMinima = dados.SEXO === "FEMININO" ? IDADE_MINIMA_F : IDADE_MINIMA_M;
          const IdadeInicial = (Idade > IdadeMinima ? Idade : IdadeMinima);

          setIdadeAposentadoria(IdadeInicial.toString());
          montarComboIdade(IdadeInicial);

          setNomeUsuario(dados.Entidade.NOME_ENTID);

          const IdadeCompleta = await FuncionarioService.BuscarIdadeCompleta();
          setIdadeCompleta(IdadeCompleta);

          const TempoPatrocinadora = await FuncionarioService.BuscarTempoPatrocinadora();
          setTempoPatrocinadora(TempoPatrocinadora);

          const src_info = await FichaFinanceiraService.BuscarSRCCD(PlanoCD.CD_PLANO);
          setSRC(src_info[0].SRC!);
          setReferencia(src_info[0].MES_COMP + "/" + src_info[0].ANO_COMP);

          const tempoPlano = await PlanoService.BuscarTempoPlano(PlanoCD.CD_PLANO);
          setTempoPlano(tempoPlano);

          const saldo = await FichaFinanceiraService.BuscarSaldoContribuicoes(PlanoCD.CD_PLANO);
          setSaldo(saldo);


          setAtivoCD(true);

          setDados(dados);
        }

        setPlano(PlanoCD || new PlanoVinculadoEntidade());
      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
        const error = err.response ? err.response.data : err;
        setAlertText(error || "Erro ao carregar o simulador, tente novamente mais tarde.");
      }
    })();
  }, []);

  function montarComboIdade(IdadeInicial: number) {
    const c: Array<ComboData> = [];

    for (let i = IdadeInicial; i < 71; i++) {
      c.push({
        Name: `${i} Anos`,
        Value: i.toString()
      });
    }

    setComboIdade(c);
  }

  async function Simular() {
    try {
      //setAlertText("Em construção.");
      // Itens selecionados:
      // IdadeAposentadoria: ${IdadeAposentadoria}
      // Percentual: ${Percentual}
      // Prazo: ${Prazo}
      // Rentabilidade: ${Rentabilidade}
      // `);
      history.push(`/simuladorAposentadoria/resultado/${IdadeAposentadoria}/${Rentabilidade}/${Prazo}/${Percentual}/${Contribuicao}`);
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      setAlertText(error);
    }
  };

  function renderSimuladorAposentadoria() {
    if (Plano !== undefined) {
      if (AtivoCD) {
        return (
          <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
            <div>
              <h3>{"Bem-Vindo ao Simulador de Aposentadoria do Plano CD!"}</h3>

              <Box title={`Olá, ${NomeUsuario}! Os dados abaixo serão utilizados na simulação da sua aposentadoria`} badgeText={`Posição de ${Referencia}`}>
                <div>
                  <Header
                    dados={Dados}
                    SRC={SRC}
                    plano={Plano}
                    tempoPlano={TempoPlano}
                    saldo={Saldo}
                    idadeCompleta={IdadeCompleta}
                    tempoPatrocinadora={TempoPatrocinadora}
                  />

                  <BoxInfoSimulador
                    titulo={"Idade para Aposentadoria"}
                    TextoAlert={`Com quantos anos você pretende se aposentar? (Mínimo de ${IDADE_MINIMA_M} anos para participantes do sexo masculino e ${IDADE_MINIMA_F} anos para os participantes do sexo feminino).`}
                    comboLabel={"Idade para Aposentadoria"}
                    dados={ComboIdade}
                    onChange={setIdadeAposentadoria}
                  />

                  <Row>
                    <Col>
                      <Box title={"Contribuição Voluntária Mensal"}>
                        <Alert type={"info"}>
                          {"Melhore sua aposentadoria realizando contribuição voluntária mensal!"}
                        </Alert>

                        {/* <Input
                          value={Contribuicao}
                          onChange={setContribuicao}
                          type={"money"}
                          title={"Contribuição Voluntária Mensal (R$)"}
                          si
                        /> */}

                        <WrapRow>
                          <AutoColumn>
                            <Label>
                              <b>
                                <label>
                                  {"Contribuição Voluntária Mensal (R$)"}
                                </label>
                              </b>
                            </Label>

                            <Input
                              value={Contribuicao}
                              onChange={setContribuicao}
                              type={"money"}
                            />

                          </AutoColumn>
                        </WrapRow>
                      </Box>
                    </Col>
                  </Row>

                  <BoxInfoSimulador
                    titulo={"Resgate de Saldo à Vista"}
                    TextoAlert={"Será facultado ao Participante na data da concessão do benefício a opção por receber a qualquer momento, na forma de pagamento único, o correspondente a até 20% (vinte por cento) da totalidade do Saldo registrado, na referida data de concessão, com a conseqüente redução do saldo a ser recebido sob a forma de qualquer uma das modalidades de renda do regulamento."}
                    comboLabel={"Percentual de Saldo à Vista"}
                    dados={ComboPercentual}
                    onChange={setPercentual}
                  />

                  <BoxInfoSimulador
                    titulo={"Renda Mensal por Prazo Certo"}
                    TextoAlert={"Escolha a quantidade em meses para o recebimento de sua Renda Mensal por Prazo Certo."}
                    comboLabel={"Prazo Renda Mensal"}
                    valorInicial={"240"}
                    dados={ComboPrazo}
                    onChange={setPrazo}
                  />

                  <BoxInfoSimulador
                    titulo={
                      <span>
                        Taxa <UnderlineBoldText>Real</UnderlineBoldText> de Rentabilidade Anual
                      </span>
                    }
                    TextoAlert={"Você pode projetar seu saldo e as contribuições futuras utilizando vários cenários de rentabilidade!"}
                    TextoAlertAlt={"Rentabilidade Real equivale a remuneração obtida além do índice de inflação."}
                    comboLabel={"Rentabilidade Anual"}
                    dados={ComboRentabilidade}
                    onChange={setRentabilidade}
                    valorInicial={"3.5"}
                  />

                  <div className={Manifesto ? "alert alert-success" : "alert alert-warning"}>
                    <ToggleBox>
                      {/* <ButtonToggle
                        onClick={() => setManifesto(!Manifesto)}
                        state={Manifesto}
                        titleOff={""}
                        titleOn={""}
                      /> */}
                      {/* <SmallButton
                        type={Manifesto ? "success" : "danger"}
                        onClick={() => setManifesto(!Manifesto)}
                      >
  {Manifesto ? <FaCheck/> : <FaTimesCircle/>}
                      </SmallButton> */}
                      <Checkbox
                        type={"checkbox"}
                        id={"manifestacao"}
                        name={"manifestacao"}
                        checked={Manifesto}
                        onChange={() => setManifesto(!Manifesto)}
                      />
                      <label htmlFor={"manifestacao"}>
                        {"Manifesto ciência que os valores de simulação tem caráter apenas ilustrativo, não gerando quaisquer direitos ao seu recebimento, e que o valor da renda dependerá do montante capitalizado resultante das contribuições efetivamente recolhidas e da rentabilidade real obtida durante o período de capitalização, bem como da característica etária do participante, na data da aposentadoria."}
                      </label>
                    </ToggleBox>
                  </div>

                  {AlertText !== "" && <Alert type={"danger"}>
                    {AlertText}
                  </Alert>}

                  <Button
                    onClick={Simular}
                    disabled={!Manifesto}
                    title={"Simular"}
                    type={"primary"}
                    block
                  />

                </div>
              </Box>
            </div>
          </MasterPage>
        );
      }

      return (
        <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
          <WrapRow>
            <Alert type={"info"}>{"Simulador de Aposentadoria disponível apenas para participantes ATIVOS do Plano CD."}</Alert>
          </WrapRow>
        </MasterPage>
      );
    }

    return (
      <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
        <WrapRow>
          <LoadingComponent />
        </WrapRow>
      </MasterPage>
    );
  }

  return renderSimuladorAposentadoria();
}
